module.exports = __webpack_public_path__ + "static/media/pre-reveal.d390b7ba.png";